import { HTTP } from '@/config/http-constants';

export default {
  list()
  {
    return HTTP.get('/public/professions/services')
  }
}
